export const utilizationDateFilterKey = 'utilization_date_filter';
export const utilizationRefreshStateKey = 'utilization_refresh_state';
export const usageDateFilterKey = 'usage_date_filter';
export const usageRefreshStateKey = 'usage_refresh_state';
export const utilizationFullGraphKey = 'full_graph';
export const apiFilterKey = 'api_filters';
export const volumeAccountIdKey = 'accountId';
